// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ParagraphElement_wrap__FTyRs"};